import styled from "styled-components";

export const MenuContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto 5px;
  padding: 0.5em 0;
  text-transform: uppercase;
  font-family: "MaisonNeueBook", sans-serif;
  font-size: 16px;
  font-weight: 400;
  a {
    color: #fff;
  }
  a:hover {
    text-decoration: none;
    color: #cff16b;
  }
`;
